import React, { Component } from 'react';

class ScannedItems extends Component {

  render(){

    const noItemsContainer = {
      textAlign: 'center',
      padding: '2em',
      color: 'rgba(255, 255, 255, 0.7)'
    }

    const headerStyle = {
      textAlign: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      padding: '0.45em 0',
      display: 'flex',
      color: 'white'
    };

    const item = {
      padding: '0.5em 0',
      display: 'flex',
      textAlign: 'center',
      borderBottom: 'solid 1px rgba(234, 234, 234, 0.2)',
      color: 'white'
    };

    const greenText = {
      color: '#5cb85c'
    };

    return (
      <div>
        {this.props.scannedItems.length > 0 ?
          <div>
            <div style={headerStyle}>
              <div className="col-3">Status</div>
              <div className="col-3">ID</div>
              <div className="col-6">Item</div>
            </div>
            {this.props.scannedItems.map((i, idx) => {
              return (
                <div style={item} key={idx}>
                  <span className="col-3" style={greenText}>Added</span>
                  <span className="col-3">#{i.id}</span>
                  <span className="col-6">{i.item.name}</span>
                </div>
              )
            })}
          </div>
        :
        <div style={noItemsContainer}>
          <div>No scanned items yet</div>
          <div><i>(Focus a QR code to scan an item)</i></div>
        </div>
        }
      </div>
    )
  }

}

export default ScannedItems;
